import {LabelName, LabelPolygon, LabelPolyline,LabelRect} from '../store/labels/types';
import { v4 as uuidv4 } from 'uuid';
import {find} from 'lodash';
import {IRect} from '../interfaces/IRect';
import {LabelStatus} from '../data/enums/LabelStatus';
import {IPoint} from '../interfaces/IPoint';
import { sample, random } from 'lodash';
import {Settings} from '../settings/Settings';
import _ from "lodash";
export class LabelUtil {
    public static createLabelName(name: string): LabelName {
        return {
            id: uuidv4(),
            name,
            color: sample(Settings.LABEL_COLORS_PALETTE)
        }
    }

    public static createLabelRect(
        labelId: string | null,
        rect: IRect,
        trackId: string | null = null
    ): LabelRect {
        const labelRect: LabelRect & { createdAt: number } = {
            id: uuidv4(),
            labelId,
            rect,
            isCreatedByAI: false,
            show: true,
            status: LabelStatus.ACCEPTED,
            suggestedLabel: null,
            confidence:1,
            createdAt: Date.now(),
        };
        // Only attach trackId when present so normal annotation payloads stay unchanged.
        if (trackId) {
            labelRect.trackId = trackId;
        }
        return labelRect;
    }

    public static createLabelPolygon(labelId: string | null, vertices: IPoint[]): LabelPolygon {
        return {
            id: uuidv4(),
            labelId,
            vertices,
            isCreatedByAI: false,
            show: true,
            createdAt: Date.now(),
        } as LabelPolygon & { createdAt: number }
    }
public static createLabelPolyline(labelId: string | null, vertices: IPoint[]): LabelPolyline {
        return {
            id: uuidv4(),
            labelId,
            vertices,
            isCreatedByAI: false,
            createdAt: Date.now(),
        } as LabelPolyline & { createdAt: number }
    }
    public static labelNamesIdsDiff(oldLabelNames: LabelName[], newLabelNames: LabelName[]): string[] {
        return oldLabelNames.reduce((missingIds: string[], labelName: LabelName) => {
            if (!find(newLabelNames, { 'id': labelName.id })) {
                missingIds.push(labelName.id);
            }
            return missingIds
        }, [])
    }
}
